// extracted by mini-css-extract-plugin
module.exports = {"ImageContainer":"ImagemConta_ImageContainer__5rQRX","Button":"ImagemConta_Button__W1nKA"};